import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { evaluateExperimentAndLog, evaluateExperiment } from '@homeaway/abacus-client-utils';
import Carousel from '../Carousel';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';
import { FormattedMessage } from '../Intl';
import { TALL_CAROUSEL_ASPECT_RATIO } from '../Carousel/constants';
import PropertyTypeCard from './PropertyTypeCard';
import { buildPropertyTypeSerpUrl } from './utils';
import { PROPERTY_TYPES_EXPERIMENT_NAME } from './constants';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';
import {
  PROPERTY_TYPES_LINK_CLICK,
  PROPERTY_TYPES_CLICK_PREV,
  PROPERTY_TYPES_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

class PropertyTypes extends Component {
  static propTypes = {
    propertyTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
    siteName: PropTypes.string.isRequired
  };

  componentDidMount() {
    const experimentData = evaluateExperiment(PROPERTY_TYPES_EXPERIMENT_NAME);
    if (!experimentData.exception) {
      evaluateExperimentAndLog(PROPERTY_TYPES_EXPERIMENT_NAME);
    }
  }

  handlePreviousClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_NEXT);
  }

  handleOnClick = propertyTypeKey => (evt) => {
    handleEdapClick(PROPERTY_TYPES_LINK_CLICK, { propertyTypeKey })(evt);
  }

  render() {
    const {
      propertyTypes,
      siteName
    } = this.props;

    return (
      <Experiment name={PROPERTY_TYPES_EXPERIMENT_NAME}>
        {propertyTypeExperimentValue => (
          propertyTypeExperimentValue === 1 &&
          <EdapModuleView
            eventOptions={MODULE_VIEW_EVENT_OPTIONS}
            tagName="section"
            className= "Content__section"
          >
            {
              propertyTypes &&
              propertyTypes.length > 0 &&
              (
                <FormattedMessage id={['propertytypes.title', 'propertytypes.tile.subtitle']}>
                  {(propertyTypesTitle, propertyTypeSubtitle) => (
                    <Carousel
                      title={propertyTypesTitle}
                      cardAspectRatio={TALL_CAROUSEL_ASPECT_RATIO}
                      onPreviousClick={this.handlePreviousClick}
                      onNextClick={this.handleNextClick}
                    >
                      {propertyTypes.map(
                        ({
                          destination,
                          propertyTypeKey,
                          formattedCount,
                          imageUri,
                          propertyTypeSerpFilter
                        }, index) => (
                          <PropertyTypeCard
                            propertyTypeKey={propertyTypeKey}
                            key={index}
                            formattedCount={formattedCount}
                            imageUri={imageUri}
                            clickUrl={buildPropertyTypeSerpUrl({ siteName, destination, propertyTypeSerpFilter })}
                            subtitleTemplate={propertyTypeSubtitle}
                            onClick={this.handleOnClick(propertyTypeKey)}
                          />
                        )
                      )}
                    </Carousel>
                  )
                  }
                </FormattedMessage>

              )}
          </EdapModuleView>
        )
        }
      </Experiment>
    );
  }
}

export default PropertyTypes;



// WEBPACK FOOTER //
// ./src/universal/components/PropertyTypes/PropertyTypes.js